import React from "react";
import { useParams } from "react-router-dom";

import AboutBusiness from "./AboutBusiness";
import AboutHistory from "./AboutHistory";
import AboutFinancialStatements from "./AboutFinancialStatements";

function AboutCaseRenderer({ subject }) {
    switch (subject) {
        case "business":
            return <AboutBusiness />;
        case "history":
            return <AboutHistory />;
        case "financialStatements":
            return <AboutFinancialStatements />;
        default:
            return <React.Fragment />;
    }
}

export default function AboutContent() {
    const { subject } = useParams();
    return (
        <>
            <AboutCaseRenderer subject={subject} />
        </>
    );
}